import script from "./AnswerEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnswerEditor.vue?vue&type=script&lang=ts&setup=true"

import "./AnswerEditor.vue?vue&type=style&index=0&id=649b8ed6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649b8ed6"]])

export default __exports__